// extracted by mini-css-extract-plugin
export default {"form_container":"FormContainer_form_container__iRJ00","form_container_IBS":"FormContainer_form_container_IBS__4fhaO"};